import React from 'react';
import { useSmartcard } from '../contexts/SmartcardContext';

interface SmartcardWidgetProps {
  compact?: boolean;
  showError?: boolean;
}

export const SmartcardWidget: React.FC<SmartcardWidgetProps> = ({ compact = false, showError = true }) => {
  const { isConnected, isConnecting, error, connect, disconnect } = useSmartcard();

  if (compact) {
    return (
      <div className="flex items-center gap-2">
        {isConnected && (
          <>
            <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
            <span className="text-xs text-green-700 dark:text-green-300">Lesegerät</span>
          </>
        )}
        {!isConnected && (
          <span className="text-xs text-gray-500 dark:text-gray-400">Kein Lesegerät</span>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {showError && error && (
        <div className="p-2 bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-100 rounded text-sm">
          ⚠️ {error}
        </div>
      )}

      <div className="flex gap-2 items-center">
        {isConnected ? (
          <>
            <div className="flex items-center gap-2 px-3 py-2 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100 rounded text-sm flex-1">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
              <span>Smartcard-Lesegerät verbunden</span>
            </div>
            <button
              onClick={disconnect}
              disabled={isConnecting}
              className="px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded text-sm disabled:opacity-50"
            >
              ✕ Trennen
            </button>
          </>
        ) : (
          <button
            onClick={connect}
            disabled={isConnecting}
            className="w-full px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded text-sm disabled:opacity-50"
          >
            {isConnecting ? '⏳ Verbinde...' : '🔗 Lesegerät verbinden'}
          </button>
        )}
      </div>
    </div>
  );
};

export const SmartcardStatusBar: React.FC = () => {
  const { isConnected, error } = useSmartcard();

  if (!isConnected && !error) return null;

  return (
    <div className="px-4 py-2 bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      {isConnected && (
        <div className="flex items-center gap-2 text-sm text-green-700 dark:text-green-300">
          <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
          Smartcard-Lesegerät verbunden und bereit
        </div>
      )}
      {error && (
        <div className="flex items-center gap-2 text-sm text-yellow-700 dark:text-yellow-300">
          ⚠️ {error}
        </div>
      )}
    </div>
  );
};
